let countrySvgIconData;

export default countrySvgIconData;
